import { useEffect, useState } from 'react'

export const useStickyGate = (value: boolean) => {
  const [output, setOutput] = useState(value)

  useEffect(() => {
    // If we're going from true to false, let's debounce that transition only
    if (output && !value) {
      const timeout = setTimeout(() => {
        setOutput(value)
      }, 1000)

      return () => clearTimeout(timeout)
    } else {
      setOutput(value)
    }
  }, [value, output])

  return output
}
